export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=403eacb9267e5f7745f6ab7a6130a4d0da6235d927&name=revalidateCommunity!'